import CovarianceType from "state/selections/Constants/CovarianceType";
import SummaryType from "state/selections/Constants/SummaryType";
import { isDefined } from "@ls/js-utils";
import scope from "./scope";

export default class BetaDefinition {
  static getDefault = () =>
    new BetaDefinition({
      betaId: 3,
      covarianceType: CovarianceType.HIST.value,
      betaValue: "TOTAL",
      summary: SummaryType.ABSOLUTE,
    });

  #betaId;
  #betaValue;
  #covarianceType;
  #covarianceEntity;
  #summary;

  constructor(props = {}) {
    const { betaId, betaValue, covarianceType, summary } = props;
    this.#betaId = Number(betaId);
    this.#betaValue = betaValue ?? "TOTAL";
    this.#covarianceType = covarianceType;
    this.#covarianceEntity = CovarianceType[this.#covarianceType];
    this.#summary = summary;
  }

  get betaId() {
    return this.#betaId;
  }

  get covarianceType() {
    return this.#covarianceType;
  }

  get betaValue() {
    return this.#betaValue;
  }

  get covarianceEntity() {
    return this.#covarianceEntity;
  }

  get summary() {
    return this.#summary;
  }

  get key() {
    return `${scope} - ${this.#betaId}, ${this.#covarianceType}, ${
      this.#betaValue
    }, ${this.#summary}`;
  }

  get complete() {
    return (
      isDefined(this.betaId) &&
      isDefined(this.covarianceType) &&
      isDefined(this.betaValue)
    );
  }

  copy = () => {
    return {
      betaId: this.betaId,
      betaValue: this.betaValue,
      covarianceType: this.covarianceType,
      summary: this.summary,
    };
  };

  setBetaId = (value) =>
    new BetaDefinition({
      ...this.copy(),
      betaId: value,
    });

  setBetaValue = (value) =>
    new BetaDefinition({
      ...this.copy(),
      betaValue: value,
    });

  setCovarianceType = (value) =>
    new BetaDefinition({
      ...this.copy(),
      covarianceType: value,
    });

  setSummary = (value) =>
    new BetaDefinition({
      ...this.copy(),
      summary: value,
    });
}
